export default class User {
  id: number;
  name: string;
  lastName: string;
  socialDenomination: string;
  email: string;
  phone: string;
  town: string;
  address: string;
  postalCode: string;
  cifNif: string;
  contactName: string;
  contactLastName: string;
  role: string;
  password: string;
  business: boolean;
  comercialName: string;
  nationality: string;

  constructor(
    id: number,
    name: string,
    lastName: string,
    socialDenomination: string,
    email: string,
    phone: string,
    town: string,
    address: string,
    postalCode: string,
    cifNif: string,
    contactName: string,
    contactLastName: string,
    role: string,
    password: string,
    business: boolean,
    comercialName: string,
    nationality: string
  ) {
    this.id = id;
    this.name = name;
    this.lastName = lastName;
    this.socialDenomination = socialDenomination;
    this.email = email;
    this.phone = phone;
    this.town = town;
    this.address = address;
    this.postalCode = postalCode;
    this.cifNif = cifNif;
    this.contactName = contactName;
    this.contactLastName = contactLastName;
    this.role = role;
    this.password = password;
    this.business = business;
    this.comercialName = comercialName;
    this.nationality = nationality;
  }
}
